import type { ProviderId } from "@/lib/powtoon-be/types";
import type { InteractionMode } from "@/lib/scenarios/interactionModes";

/**
 * Which providers support each interaction mode. Kaltura's conversation is
 * generated by us and D-ID's is captured live from its SDK, so both produce a
 * transcript just like the polled providers. Role-play has no scoring wired up
 * for any provider yet, but the flow itself runs.
 */
export const PROVIDERS_BY_MODE: Record<InteractionMode, ProviderId[]> = {
  conversational: ["liveavatar", "tavus", "did", "kaltura"],
  multiple_choice: ["liveavatar", "tavus", "did", "kaltura"],
  role_play: ["liveavatar", "tavus", "did", "kaltura"],
};

/** Intersect the org's available providers with those that support `mode`. */
export function providersForMode(
  mode: InteractionMode,
  orgAvailable: ProviderId[],
): ProviderId[] {
  const supported = PROVIDERS_BY_MODE[mode];
  return orgAvailable.filter((p) => supported.includes(p));
}